import tns from 'tiny-slider'

const elements = document.querySelectorAll('.js-testimonials')
for (let i = elements.length; i--;) {
  initTestimonialsSlider(elements[i])
}

function initTestimonialsSlider (container) {
  tns({
    container,
    items: 1,
    slideBy: 'page',
    controls: false
  })
}
